/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
// import Paper from '@mui/material/Paper';
// import LinkOffIcon from '@mui/icons-material/LinkOff';
// import Avatar from '@mui/material/Avatar';
import queryString from 'query-string';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Success from '../../assets/images/success.png';
import PaymentAction from '../../store/actions/PaymentAction';
import Loader from './Loader';
// import LinkExpired from './LinkExpired';

function PaymentSuccess() {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { code } = useParams();
  const queryParams = queryString.parse(location.search);
  const { token, PayerID } = queryParams; // Use object destructuring to extract token

  console.log(token, 'token');
  console.log(PayerID, 'PayerID');

  useEffect(() => {
    if (token && PayerID) {
      // Forward the encrypted invoice id (`code`) so the backend can bind the
      // capture to the invoice the buyer actually opened, not PayPal's reference alone.
      dispatch(PaymentAction.paypalSuccess(token, PayerID, code))
        .then(() => {
          if (code) {
            dispatch(PaymentAction.getPaymentStatus(code, navigate));
          }
        })
        .catch((err) => {
          console.error('Paypal error:', err);
          // if (err?.response?.status === 422 && code) {
          //   dispatch(PaymentAction.getPaymentStatus(code, navigate));
          // }
        });
    }
  }, [dispatch, token, PayerID, code, navigate]);

  useEffect(() => {
    if (!token && !PayerID && code) {
      // For non-Paypal payment success
      dispatch(PaymentAction.getPaymentStatus(code, navigate));
    }
  }, [dispatch, code, token, PayerID, navigate]);

  const { paymentStatus, isLoading } = useSelector((state) => state.payment);
  console.log(paymentStatus);

  return (
    <Box className="invoiceAppLoginWrap">
      <Grid container spacing={2} justifyContent="center">
        <Grid item xs={5} md={5}>
          <Box className="loginRightForm">
            <Box
              className="loginFormWrap"
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh'
              }}
            >
              {/* Show the loader until the payment data is ready — the capture
                  call (paypalSuccess) runs for a few seconds without flipping
                  isLoading, which otherwise leaves the page blank/white. */}
              {(isLoading || !(paymentStatus && Object.keys(paymentStatus).length > 0)) && (
                <Loader />
              )}
              {paymentStatus && Object.keys(paymentStatus).length > 0 && (
                <Box className="logninInner">
                  <img alt="Payment Cancelled" src={Success} />
                  <Typography variant="h3" gutterBottom component="" mb={2}>
                    Payment Successful
                  </Typography>
                  <Typography
                    variant="body1"
                    align="center"
                    sx={{ fontSize: '16px !important' }}
                    className="subtitle"
                    component="p"
                    mb={2}
                  >
                    Your payment has been successfully processed. Thank you for completing the
                    payment!
                  </Typography>
                  <List sx={{ maxWidth: '500px', margin: '0 auto' }}>
                    {Object.entries(paymentStatus).map(([key, value]) => (
                      <>
                        <ListItem
                          key={key}
                          secondaryAction={
                            <Typography
                              sx={{ fontSize: '13px' }}
                              variant="body1"
                              component="p"
                              mb={0}
                            >
                              {String(value)}
                            </Typography>
                          }
                        >
                          <ListItemText
                            sx={{
                              '.MuiListItemText-primary': {
                                fontSize: '13px',
                                fontWeight: 'bold'
                              }
                            }}
                            primary={key.replace(/_/g, ' ').toUpperCase()}
                          />
                        </ListItem>
                        <Divider />
                      </>
                    ))}
                  </List>
                </Box>
              )}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default PaymentSuccess;
